"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactToastify = require("react-toastify");

var _ToastMessage = _interopRequireDefault(require("./ToastMessage"));

var _CustomCloseButton = _interopRequireDefault(require("./CustomCloseButton"));

var TOAST_TYPES = {
  success: _reactToastify.toast.TYPE.SUCCESS,
  info: _reactToastify.toast.TYPE.INFO,
  error: _reactToastify.toast.TYPE.ERROR
};

var showToast = function showToast(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'info' : _props$type,
      _props$text = props.text,
      text = _props$text === void 0 ? '' : _props$text,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      containerId = props.containerId,
      content = props.content,
      closeButton = props.closeButton,
      closeButtonClassName = props.closeButtonClassName,
      newProps = (0, _objectWithoutProperties2.default)(props, ["type", "text", "title", "containerId", "content", "closeButton", "closeButtonClassName"]);

  if (content) {
    var properties = {
      closeButton: closeButton,
      closeButtonClassName: closeButtonClassName
    };
    return (0, _reactToastify.toast)(content, (0, _extends2.default)({
      containerId: containerId || 'hoi-poi-ui',
      closeButton: /*#__PURE__*/_react.default.createElement(_CustomCloseButton.default, {
        properties: properties
      })
    }, newProps));
  }

  var toastType = TOAST_TYPES[type];
  var messageProps = {
    title: title,
    text: text,
    type: type
  };
  return (0, _reactToastify.toast)( /*#__PURE__*/_react.default.createElement(_ToastMessage.default, messageProps), (0, _extends2.default)({
    type: toastType,
    containerId: containerId || 'hoi-poi-ui'
  }, newProps));
};

var _default = showToast;
exports.default = _default;